import { FC, Fragment } from "react";
import { Stack, Typography } from "@mui/material";
import { ResourceExplorerGroupingNullable } from "@/services/cloudchipr.api";

export interface LabelColumnHeaderCellProps {
  grouping: ResourceExplorerGroupingNullable;
  groupingLabel: string;
  dataCount?: number | null;
}

export const LabelColumnHeaderCell: FC<LabelColumnHeaderCellProps> = ({
  grouping,
  groupingLabel,
  dataCount,
}) => {
  if (!grouping) {
    return <Fragment>Total</Fragment>;
  }

  if (grouping === "none") {
    return null;
  }

  return (
    <Stack direction="row" spacing={2} alignItems="center">
      <div>
        <Typography fontWeight="medium" variant="body2" color="text.primary">
          {groupingLabel}
        </Typography>

        <Typography fontSize={10} color="text.disabled" fontWeight={500}>
          {dataCount}
        </Typography>
      </div>
    </Stack>
  );
};
